module.exports = __webpack_public_path__ + "static/media/22_tn.5a564b2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/22_tn.jpg
// module id = 510
// module chunks = 0